import { EcpStoreType } from '../rest/ecp-locator';

export type EcpMapUserLocation = {
  latitude?: number;
  longitude?: number;
};

export interface UpdateStores {
  filters?: TFiltersData;
  userLocation?: EcpMapUserLocation;
}

export type ServiceTypeFilters = EcpStoreType.retailer | EcpStoreType.fitter | EcpStoreType.c2cActivated | null;

export enum SpecializationTypeFilters {
  astigmatism = 'astigmatism',
  presbyopia = 'presbyopia',
  children = 'children',
  myopiaControl = 'myopia_control',
}

export enum ShopTypeFilters {
  optics = 'optics',
  clinics = 'clinics',
  vendings = 'vendings',
}

export type TFiltersData = {
  specializations: SpecializationTypeFilters[];
  shops: ShopTypeFilters[];
  c2cActivated?: boolean;
  services?: ServiceTypeFilters;
  isSurgeryClinic?: boolean;
};
